module.exports = "/shifts/components/calendarHeader/managerHeaderWeek-f81dd0.html";